export default {"src":"/_next/static/media/megaphone_bold.022dcab7.svg","height":24,"width":24};